export var APP_HEADER_TITLE = 'EVENTS_MA_PAGE.APP_HEADER_TITLE';
export var APP_HEADER_DESCRIPTION = 'EVENTS_MA_PAGE.APP_HEADER_DESCRIPTION';
export var EVENT_SUMMARY = 'EVENTS_MA_PAGE.EVENT_SUMMARY';
export var NO_EVENTS = 'EVENTS_MA_PAGE.NO_EVENTS';
export var EVENT_LIST_TABS = 'EVENTS_MA_PAGE.EVENT_LIST_TABS';
export var EVENT_TITLE = 'EVENTS_MA_PAGE.EVENT_TITLE';
export var ORDER_DETAILS = 'EVENTS_MA_PAGE.ORDER_DETAILS';
export var EXPANDABLE_ROW = 'EVENTS_MA_PAGE.EXPANDABLE_ROW';
export var EXPANDABLE_ROW_ICON = 'EVENTS_MA_PAGE.EXPANDABLE_ROW_ICON';
export var START_DATE = 'EVENTS_MA_PAGE.START_DATE';
export var FULL_LOCATION = 'EVENTS_MA_PAGE.FULL_LOCATION';
export var BUTTON_GO_TO_DETAILS = 'EVENTS_MA_PAGE.BUTTON_GO_TO_DETAILS';
export var BUTTON_CANCEL_RSVP = 'EVENTS_MA_PAGE.BUTTON_CANCEL_RSVP';
export var BUTTON_SHARE = 'EVENTS_MA_PAGE.BUTTON_SHARE';
export var BUTTON_SHOW_ORDERS = 'EVENTS_MA_PAGE.BUTTON_SHOW_ORDERS';
export var BUTTON_DOWNLOAD_TICKETS = 'EVENTS_MA_PAGE.BUTTON_DOWNLOAD_TICKETS';
export var BUTTON_GO_TO_EVENTS = 'EVENTS_MA_PAGE.BUTTON_GO_TO_EVENTS';
export var BACK_BUTTON = 'EVENTS_MA_PAGE.BACK_BUTTON';
export var MOBILE_ORDER_NUMBER = 'EVENTS_MA_PAGE.MOBILE_ORDER_NUMBER';
export var MOBILE_ORDER_DATE = 'EVENTS_MA_PAGE.MOBILE_ORDER_DATE';
export var MOBILE_ORDER_TOTAL = 'EVENTS_MA_PAGE.MOBILE_ORDER_TOTAL';
export var MOBILE_ORDER_DETAILS_NUMBER = 'EVENTS_MA_PAGE.MOBILE_ORDER_DETAILS_NUMBER';
export var MOBILE_ORDER_DETAILS_TOTAL = 'EVENTS_MA_PAGE.MOBILE_ORDER_DETAILS_TOTAL';
export var MOBILE_BUTTON_DOWNLOAD_TICKETS = 'EVENTS_MA_PAGE.MOBILE_BUTTON_DOWNLOAD_TICKETS';
export var TICKET = 'EVENTS_MA_PAGE.TICKET';
export var TICKET_TOTAL = 'EVENTS_MA_PAGE.TICKET_TOTAL';
export var DISCOUNT_TOTAL = 'EVENTS_MA_PAGE.DISCOUNT_TOTAL';
export var SUBTOTAL = 'EVENTS_MA_PAGE.SUBTOTAL';
export var TAX = 'TAX';
export var SUBTOTALS_CONTAINER = 'SUBTOTALS_CONTAINER';
export var EVENTS_MA_PAGE_APP_HEADER_TITLE = 'EVENTS_MA_PAGE.APP_HEADER_TITLE';
export var EVENTS_MA_PAGE_APP_HEADER_DESCRIPTION = 'EVENTS_MA_PAGE.APP_HEADER_DESCRIPTION';
export var EVENTS_MA_PAGE_EVENT_LIST_TABS = 'EVENTS_MA_PAGE.EVENT_LIST_TABS';
export var EVENTS_MA_PAGE_EXPANDABLE_ROW = 'EVENTS_MA_PAGE.EXPANDABLE_ROW';
export var EVENTS_MA_PAGE_EXPANDABLE_ROW_ICON = 'EVENTS_MA_PAGE.EXPANDABLE_ROW_ICON';
export var EVENTS_MA_PAGE_EVENT_TITLE = 'EVENTS_MA_PAGE.EVENT_TITLE';
export var EVENTS_MA_PAGE_BUTTON_GO_TO_DETAILS = 'EVENTS_MA_PAGE.BUTTON_GO_TO_DETAILS';
export var EVENTS_MA_PAGE_BUTTON_CANCEL_RSVP = 'EVENTS_MA_PAGE.BUTTON_CANCEL_RSVP';
export var EVENTS_MA_PAGE_BUTTON_DOWNLOAD_TICKETS = 'EVENTS_MA_PAGE.BUTTON_DOWNLOAD_TICKETS';
export var EVENTS_MA_PAGE_BUTTON_SHARE = 'EVENTS_MA_PAGE.BUTTON_SHARE';
//# sourceMappingURL=members-page.js.map